export default class AppError extends Error
{

   constructor(message: string) {
      super(message);
      Object.setPrototypeOf(this, AppError.prototype);
   }
}

export function handleError(error :unknown) :unknown {
   if(error instanceof AppError)
      if(location.href.includes('localhost')) {
         alert(error.message);
         console.error(error);

      }else {
         //@todo např. poslat message na server?
      }

   return error;
}
